<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { inject } from 'vue'
import { EHubContext } from '../../../types/context/HubContextEnum'
import CheckpointClearDetectionsAction from '../../EventsView/Detail/CheckpointsTable/components/CheckpointClearDetectionsAction.vue'

type Props = {
    data: CheckpointModel
}
defineProps<Props>()

const isViewerOnly = inject<boolean>(EHubContext.IS_VIEWER_ONLY, false)
</script>

<template>
    <InformationBaseCard
        :label="$t('checkpoint.title.actionsTitle')"
        class="fit-width checkpoint-actions"
        v-if="!isViewerOnly">
        <CheckpointClearDetectionsAction :data="data" />
    </InformationBaseCard>
</template>

<style scoped lang="scss">
.checkpoint-actions {
    &:deep(.erase-button) {
        border-radius: 4px;
    }
}
</style>
